import { apiClient } from './apiService';

const directMessageService = {
  getConversations() {
    return apiClient.get('/dm/conversations').then((r) => r.data);
  },
  // Newest page first; pass `before` (the oldest message id you hold) to
  // load older messages. Response: { messages, has_more, next_before }.
  getMessages(userId, { limit = 50, before } = {}) {
    const params = { limit };
    if (before) params.before = before;
    return apiClient.get(`/dm/${userId}`, { params }).then((r) => r.data);
  },
  sendMessage(userId, content) {
    return apiClient.post(`/dm/${userId}`, { content }).then((r) => r.data);
  },
  getUnreadCount() {
    return apiClient.get('/dm/unread-count').then((r) => r.data);
  },
};

export default directMessageService;
